import { connect } from '@ardoq/rxbeach';
import { TransferConfigsTable } from 'integrations/common/components/transferConfigsTable/TransferConfigsTable';
import { viewModel$ } from './viewModel$';

export const TransferConfigs = connect(TransferConfigsTable, viewModel$);
